import { useEffect, useRef } from 'react'

/**
 * useNonIdempotentEffect
 *
 * Runs the effect only once, even in React Strict Mode (which runs effects twice in dev).
 * Useful for non-idempotent effects.
 *
 * @param effectFn Effect function to run once
 */
export function useNonIdempotentEffect(effectFn: () => void | (() => void), deps: any[]) {
    const isFirstInvocationRef = useRef(true)
    useEffect(() => {
        // Ignore first call in development environment.
        // We ignore the first call and not the second, because the component unload cleanup
        // function from the first call can mess up the state of the second call, if
        // effectFn() is not idempotent.
        if (process.env.NODE_ENV === 'development') {
            if (isFirstInvocationRef.current) {
                isFirstInvocationRef.current = false
                return
            }
        }

        return effectFn()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps)
}
